import { FavorFieldsProps } from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/fields/RegItemFields.types'

import Image from 'components/image'
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconButton, Textarea } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { EditPencil } from 'baby-design/icons'

import { RegItem } from 'src/types/regItem'
import NiceModal from '@ebay/nice-modal-react'
import FavorsSection from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/fields/FavorFields/components/FavorsSection/FavorsSection'
import EditItemDetailsPrivateItemSetting from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/PrivateItem/PrivateItem'
import EditRegItemDrawer from '../EditRegItemDrawer'
import ProductInfoDrawer from '../../ProductInfoDrawer/ProductInfoDrawer'
import { CategoryDropdown } from '../components/CategoryDropdown'
import css from './fields.style.scss'
import { EditItemDetailsFavoriteSetting } from '../components/Favorite'
import { EditItemDetailsQuantitySetting } from '../components/QuantitySetting'

export function FavorFields({
  regItem,
  reservations,
  categories,
  regItemFields,
  updateRegItemFields,
  handleDelete,
  onRegItemUpdated,
}: FavorFieldsProps) {
  const openProductInfoDrawer = async () => {
    const response: RegItem | undefined = await NiceModal.show(
      ProductInfoDrawer,
      { regItem }
    )
    if (response) {
      NiceModal.show(EditRegItemDrawer, { regItem: response })
    }
  }

  return (
    <div className={css.fields}>
      <div className={css.fields__item_intro}>
        <Image
          alt={regItemFields.title}
          className={css.fields__item_intro_img}
          src={regItemFields.imgUrl}
        />
        <div className={css.fields__item_intro_info}>
          <div className={css.fields__item_title}>{regItemFields.title}</div>
        </div>
        <IconButton
          className={css.fields__image_edit}
          size="sm"
          variant="fill-inverted"
          onClick={openProductInfoDrawer}
        >
          <EditPencil />
        </IconButton>
      </div>
      <div className={css.fields__item_details}>
        <div className={css.fields__item_input}>
          <CategoryDropdown
            categories={categories}
            regItemFields={regItemFields}
            updateRegItemFields={updateRegItemFields}
          />
          <Textarea
            label="Notes to friends and family "
            placeholder="Let your Gift Givers know how they can help!"
            size="md"
            value={regItemFields.description || undefined}
            onChange={(e) =>
              updateRegItemFields({ description: e.target.value })
            }
          />
        </div>
        <EditItemDetailsQuantitySetting
          handleDelete={handleDelete}
          regItemFields={regItemFields}
          updateRegItemFields={updateRegItemFields}
        />
        <FavorsSection
          regItem={regItemFields}
          reservations={reservations}
          onRegItemUpdated={onRegItemUpdated}
        />
        <EditItemDetailsFavoriteSetting
          regItemFields={regItemFields}
          updateRegItemFields={updateRegItemFields}
        />
        <EditItemDetailsPrivateItemSetting
          categories={categories}
          regItemFields={regItemFields}
          updateRegItemFields={updateRegItemFields}
        />
      </div>
      <div className={css.fields__divider} />
      <div className={css.fields__item_delete}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <a className={css.fields__delete_link} onClick={handleDelete}>
          Delete item
        </a>
      </div>
    </div>
  )
}
